import { render, staticRenderFns } from "./ProductsTable.vue?vue&type=template&id=d09a9ece&scoped=true&"
import script from "./ProductsTable.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ProductsTable.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ProductsTable.vue?vue&type=style&index=0&id=d09a9ece&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09a9ece",
  null
  
)

export default component.exports